import { Container, IconButton, makeStyles, Paper, Typography, Snackbar, Grid, TextField, Button, InputAdornment } from '@material-ui/core'
import React, { useEffect } from 'react'
import BackIcon from '@material-ui/icons/ArrowBackIos';
import { Alert } from '@material-ui/lab';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import Parse from 'parse';
import { async } from 'parse/lib/browser/Storage';
import { createTheme } from "@material-ui/core";
import AttachFile from '@material-ui/icons/AttachFile';
import orange from '@material-ui/core/colors/orange';
import CardActions from '@material-ui/core/CardActions';
import Delete from '@material-ui/icons/Delete';
import axios from 'axios';

const ASSETS_MICROSERVICE_URL = 'http://157.230.55.48:60300'

const defaultMaterialTheme = createTheme({
    palette: {
        primary: orange,
    },
});

const useStyles = makeStyles(theme => ({
    header: {
        backgroundColor: theme.palette.nav.app,
        [theme.breakpoints.up('sm')]: {
            paddingRight: 104,
            paddingLeft: 104
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: 48,
            paddingLeft: 48
        }
    },
    headerText: {
        color: '#000',
        fontSize: 28,
        marginTop: 10,
        marginBottom: 10
    },
    titleText: {
        fontSize: 18,
        fontWeight: 600,
        margin: '20px 0px'
    },
    input: {
        display: 'none',
    }
}));

const Documents = ({ changeView }) => {

    const classes = useStyles()
    const user = JSON.parse(localStorage.user)

    const [data, setData] = React.useState({
        cuit: "",
        monto: "",
    });

    const [open, setOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [selectedURLMonto, setSelectedURLMonto] = React.useState(null);
    const [selectedFileMonto, setSelectedFileMonto] = React.useState(null);
    const [selectedURLCuit, setSelectedURLCuit] = React.useState(null);
    const [selectedFileCuit, setSelectedFileCuit] = React.useState(null);


    useEffect(() => {
        if (user) {
            setData({
                cuit: user.documentation.cuit && user.documentation.cuit.number ? user.documentation.cuit.number : data.cuit,
                monto: user.documentation.brutos && user.documentation.brutos.monto ? user.documentation.brutos.monto : data.monto,
            })
            if (typeof user.documentation.cuit.urlDoc != 'object') setSelectedURLCuit(user.documentation.cuit.urlDoc)
            if (typeof user.documentation.brutos.urlDoc != 'object') setSelectedURLMonto(user.documentation.brutos.urlDoc)
        }
    }, [])

    function dataURLtoFile(dataurl, filename) {


        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }


    const saveImgDitalOcean = async (archivo, cod) => {

        const fileName = `${Date.now()}${user.k ? user.k : ''}_${cod}` + ".jpg"
        const _data = new FormData();
        _data.append('my-file', archivo, fileName);

        const config = {
            method: 'POST',
            body: _data
        };

        const resultURL = await fetch(`${ASSETS_MICROSERVICE_URL}/file/RegisteredCustomers/${window.localStorage.getItem('envId')}`, config); // MICROSERVICIO 
        return resultURL.json();
    }


    const saveChanges = (urlMonto, urlCuit) => {
        const Customers = Parse.Object.extend("RegisteredCustomers");
        const query = new Parse.Query(Customers);
        let obj = {
            cuit: {
                number: data.cuit ? data.cuit : "",
                urlDoc: urlCuit ? urlCuit : ""
            },
            brutos: {
                monto: data.monto ? data.monto : "",
                urlDoc: urlMonto ? urlMonto : ""
            },
            ultimaModificacion: Date.now()
        }

        return query.get(user.id)
            .then((userToUpdate) => {
                if (obj) userToUpdate.set("documentation", obj);
                return userToUpdate.save()
            });
    };



    const handleSubmit = async () => {
        let urlCuit, urlMonto;
        if (selectedURLMonto) {
            if (selectedFileMonto) {
                let resURLmonto = await saveImgDitalOcean(selectedFileMonto, 'ingresos-brutos')
                if (resURLmonto && Object.values(resURLmonto)[0] && Object.values(resURLmonto)[0].rURL) {
                    urlMonto = Object.values(resURLmonto)[0].rURL
                }
            } else {
                urlMonto = selectedURLMonto
            }
        }
        if (selectedURLCuit) {
            if (selectedFileCuit) {
                let resURLCuit = await saveImgDitalOcean(selectedFileCuit, 'constancia-cuit')
                if (resURLCuit && Object.values(resURLCuit)[0] && Object.values(resURLCuit)[0].rURL) {
                    urlCuit = Object.values(resURLCuit)[0].rURL
                }
            } else {
                urlCuit = selectedURLCuit
            }
        }
        try {
            const updatedUser = await saveChanges(urlMonto, urlCuit);
            if (updatedUser.attributes) {
                localStorage.user = JSON.stringify({ ...updatedUser.attributes, id: updatedUser.id })
                setOpen(true);
                const emailBody = `
                    <h3>DATOS Y ARCHIVOS ADJUNTOS</h3>
                    <ul>
                        <li>CUIT: ${data.cuit ? data.cuit : "-"}</li>
                        <li>ARCHIVO ADJUNTO: ${urlCuit ? urlCuit : "-"}</li>
                        <p> </p>
                        <li>INGRESOS BRUTOS: ${data.monto ? data.monto : "-"}</li>
                        <li>ARCHIVO ADJUNTO: ${urlMonto ? urlMonto : "-"}</li>
                    </ul>
                `;
                await axios.post("http://157.230.55.48:5001/api/v1/kiri/sendDocumentation", {
                    email: 'flor.narvaez@razycia.com',
                    htmlEmail: emailBody,
                    title: 'DOCUMENTACIÓN DE MODIFICAIÓN/ALTA CLIENTE'
                })
            } else {
                setErrorOpen(true);
            }
        } catch (error) {
            setErrorOpen(true);
        }

    }



    const handleFileCuitChange = (x) => {
        var reader = new FileReader();
        reader.readAsDataURL(x.target.files[0]);
        reader.onload = function () {
            setSelectedURLCuit(reader.result)
        };
        setSelectedFileCuit(x.target.files[0]);
    };

    const handleFileMontoChange = (x) => {
        var reader = new FileReader();
        reader.readAsDataURL(x.target.files[0]);
        reader.onload = function () {
            // cb(reader.result)
            setSelectedURLMonto(reader.result)
        };
        setSelectedFileMonto(x.target.files[0]);
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };



    return (
        <div >
            <div className={classes.header}>
                {

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                        <div style={{ zIndex: 1 }}>

                            <p className={classes.headerText}>
                                <IconButton onClick={() => { changeView(null, 1) }} aria-label="delete" size="small">
                                    <BackIcon style={{ fontSize: 24 }} />
                                </IconButton> Documentación</p>
                        </div>
                    </div>
                }


            </div>
            <Container maxWidth="lg" style={{ paddingTop: 30, marginBottom: 30 }} >
                <Paper elevation={2} style={{ padding: '20px 60px', borderRadius: 16 }}>
                    <Typography className={classes.titleText}>
                        Documentación
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField type="number" value={data.cuit} fullWidth onChange={handleFieldChange} label="Constancia de CUIT" name='cuit' />
                            <Grid style={{ marginBottom: 5, marginTop: 5, marginLeft: -8 }}>
                                {/*<Typography variant="h6" gutterBottom>Adjunte archivos con documentación</Typography>*/}
                                <input
                                    accept="image/*,.jpg, .png, .doc"
                                    className={classes.input}
                                    id="contained-button-file-cuit"
                                    //multiple
                                    type="file"
                                    onChange={handleFileCuitChange}
                                />
                                <label htmlFor="contained-button-file-cuit">
                                    <Button color="primary" component="span" size={"small"} multiple startIcon={<AttachFile />}>
                                        Adjuntar constancia
                                    </Button>
                                </label>
                                <div style={{ display: "flex", flexDirection: "row", }}>
                                    {selectedURLCuit && selectedURLCuit.length > 0 ?
                                        <Paper elevation={2} style={{ width: 110, height: 170, margin: 5, textAlign: "center", alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                            <img alt="" style={{ width: 100, height: 100, borderRadius: 5 }} src={selectedURLCuit}></img>
                                            <CardActions disableSpacing>
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedURLCuit(null)
                                                        setSelectedFileCuit(null)
                                                    }}
                                                    aria-label="Borrar"
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </CardActions>
                                        </Paper>


                                        : null}
                                </div>

                            </Grid>
                        </Grid>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField type="number" value={data.monto} fullWidth onChange={handleFieldChange} label="Ingresos Brutos" name='monto' />
                            <Grid style={{ marginBottom: 5, marginTop: 5, marginLeft: -8 }}>
                                {/*<Typography variant="h6" gutterBottom>Adjunte archivos con documentación</Typography>*/}
                                <input
                                    accept="image/*,.jpg, .png, .doc"
                                    className={classes.input}
                                    id="contained-button-file-monto"
                                    //multiple
                                    type="file"
                                    onChange={handleFileMontoChange}
                                />
                                <label htmlFor="contained-button-file-monto">
                                    <Button color="primary" component="span" size={"small"} multiple startIcon={<AttachFile />}>
                                        Adjuntar ingresos
                                    </Button>
                                </label>

                                <div style={{ display: "flex", flexDirection: "row", }}>
                                    {selectedURLMonto && selectedURLMonto.length > 0 ?
                                        <Paper elevation={2} style={{ width: 110, height: 170, margin: 5, textAlign: "center", alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                            <img alt="" style={{ width: 100, height: 100, borderRadius: 5 }} src={selectedURLMonto}></img>
                                            <CardActions disableSpacing>
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedURLMonto(null)
                                                        setSelectedFileMonto(null)
                                                    }}
                                                    aria-label="Borrar"
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </CardActions>
                                        </Paper>


                                        : null}
                                </div>

                            </Grid>

                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: 20, textAlign: 'end' }} >
                            <Button style={{ borderRadius: 30 }} onClick={() => handleSubmit()} variant="contained" component="span" color="secondary">Guardar cambios</Button>
                        </Grid>
                    </Grid>
                </Paper>
                <Snackbar open={open} autoHideDuration={1700} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success">
                        Los cambios se guardaron correctamente!
                    </Alert>
                </Snackbar>
                <Snackbar open={errorOpen} autoHideDuration={1700} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="danger">
                        No se pudieron guardar los cambios!
                    </Alert>
                </Snackbar>
            </Container>

        </div>
    )
}

export default Documents